const updatesData = [
  { date: '2026-07-28', title: '91免费看片 V8.2.1 版本发布', tag: '版本更新', tagColor: 'bg-primary-100 text-primary-700', desc: '修复了部分机型播放卡顿问题，新增暗色模式与倍速播放功能。' },
  { date: '2026-07-25', title: '暑期档热门影视资源集中上线', tag: '资源更新', tagColor: 'bg-accent-100 text-accent-800', desc: '新增200+热门影视内容，涵盖国产剧、韩剧、美剧及院线大片。' },
  { date: '2026-07-20', title: '91免费iOS客户端通过安全认证', tag: '平台公告', tagColor: 'bg-secondary-100 text-secondary-800', desc: 'iOS版本已完成企业签名认证，安装更便捷，使用更安心。' },
  { date: '2026-07-15', title: '服务器全面升级，播放更流畅', tag: '系统公告', tagColor: 'bg-primary-100 text-primary-700', desc: '新增多地CDN节点，全国用户播放缓冲时间平均降低60%。' },
  { date: '2026-07-10', title: 'Mac客户端 V3.0 正式发布', tag: '版本更新', tagColor: 'bg-accent-100 text-accent-800', desc: '原生适配Apple Silicon，支持画中画播放与Touch Bar快捷操作。' },
  { date: '2026-07-05', title: '「免费看片软件安全白皮书」发布', tag: '安全公告', tagColor: 'bg-secondary-100 text-secondary-800', desc: '详细说明91免费软件安全机制，教你识别假冒软件与钓鱼网站。' },
  { date: '2026-06-28', title: '91免费看片的app用户突破3000万', tag: '里程碑', tagColor: 'bg-primary-100 text-primary-700', desc: '感谢每一位用户的支持，我们将继续优化产品体验。' },
  { date: '2026-06-20', title: '新增AI字幕翻译与语音搜索功能', tag: '功能更新', tagColor: 'bg-accent-100 text-accent-800', desc: '支持多语种字幕实时翻译，语音搜索看片内容更快捷。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-500">91免费平台更新、版本发布与重要公告</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden sm:block"></div>
          <div className="space-y-5">
            {updatesData.map((item, i) => (
              <div key={i} className="flex gap-5">
                <div className="hidden sm:flex flex-col items-center flex-shrink-0 pt-1">
                  <span className={`w-[10px] h-[10px] rounded-full ${
                    i === 0 ? 'bg-primary-500 ring-4 ring-primary-100' :
                    i === 1 ? 'bg-accent-500 ring-4 ring-accent-100' :
                    'bg-secondary-400 ring-4 ring-secondary-100'
                  }`}></span>
                </div>
                <div className="flex-1 min-w-0 pb-5 border-b border-background-200/60 last:border-0 last:pb-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${item.tagColor}`}>{item.tag}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <a href="#index" className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
            查看更多动态
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}